import { render, staticRenderFns } from "./Row12.vue?vue&type=template&id=8b948dc0&scoped=true"
import script from "./Row12.vue?vue&type=script&lang=js"
export * from "./Row12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b948dc0",
  null
  
)

export default component.exports